module.exports = __webpack_public_path__ + "static/img/74 (3).34c330d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/74 (3).jpg
// module id = KpiV
// module chunks = 0